import TraitsAndDimensionsDownloadButton from "@/components/traits/shared/TraitsDownloadButton/TraitsAndDimensionsDownloadButton";
import styles from "./ArchetypeGroupLeftBar.module.css";

type Props = {
  description: string;
};

export default function ArchetypeGroupLeftBar(props: Props) {
  return (
    <div className={styles.leftBarMain}>
      <div>
        <span className={styles.descTitleDiv}>
          <h4 className={styles.descriptionTitle}>Description</h4>
        </span>
        <p className={styles.description}>{props.description}</p>
      </div>
      <div className={styles.buttonDiv}>
        <TraitsAndDimensionsDownloadButton message="Find your score on over 100 traits on Dimensional." />
      </div>
    </div>
  );
}
